import { getAnalytics, logEvent, isSupported, Analytics } from 'firebase/analytics';
import { app } from '../firebase';

let analyticsInstance: Analytics | null = null;

async function getAnalyticsInstance(): Promise<Analytics | null> {
  if (analyticsInstance) return analyticsInstance;
  const supported = await isSupported();
  if (!supported) return null;
  if (!process.env.REACT_APP_FIREBASE_MEASUREMENT_ID) return null;
  analyticsInstance = getAnalytics(app);
  return analyticsInstance;
}

/**
 * Track a screen view (called when user navigates to a new route)
 */
export async function trackScreen(screenName: string) {
  try {
    const analytics = await getAnalyticsInstance();
    if (!analytics) return;
    logEvent(analytics, 'screen_view', { firebase_screen: screenName, firebase_screen_class: screenName });
  } catch {}
}

/**
 * Track a custom event (e.g. button clicks, actions)
 */
export async function trackEvent(eventName: string, params?: Record<string, string | number | boolean>) {
  try {
    const analytics = await getAnalyticsInstance();
    if (!analytics) return;
    logEvent(analytics, eventName as string & {}, params);
  } catch {}
}

// Key events to track across the app:
// trackEvent('signup_complete', { visa_type, country })
// trackEvent('post_created', { post_type })
// trackEvent('job_applied', { job_title })
// trackEvent('ai_question_asked')
// trackEvent('invite_sent')
// trackEvent('chat_opened')
